import { ReactComponent as WaymoreLogo } from "../../assets/waymore.svg";

import {
  GlobalHeaderInnerGrid,
  GlobalHeaderLogoTextContainer,
  GlobalHeaderImageContainer,
  GlobalHeadingText,
} from "./styled";

export default function GlobalHeader() {
  return (
    <GlobalHeaderInnerGrid>
      <GlobalHeaderLogoTextContainer>
        <GlobalHeaderImageContainer>
          <WaymoreLogo />
        </GlobalHeaderImageContainer>
        <GlobalHeadingText>Conversational Form Builder</GlobalHeadingText>
      </GlobalHeaderLogoTextContainer>
    </GlobalHeaderInnerGrid>
  );
}
